module.exports = __webpack_public_path__ + "static/media/dan-avatar.018dedd7.png";